<template>
    <router-view :key="$route.fullPath"></router-view>
</template>
<script>
import router from '@/router';

export default {
    name: "GamesModule",
}
</script>